import {Generic3FieldSection, KorpTestSection} from 'app/Views/Tests'
import * as React from 'react'

type PreviewProps = {
    data?: any
    preview: boolean
}

export class Generic3FieldForm extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.data ? <Generic3FieldSection
            section={this.props.data as KorpTestSection[]}
            preview={this.props.preview}
        /> : ''}
    </>
}